/**
 * Created by fajar on 01/22/2018.
 *
 * Config for mapping route for every pages
 * please use loadPage to split code to ensure
 * not load all pages in one request
 */

import Constant from "./Constant";
import Notification from "../Notification";

const pageModules = import.meta.glob("../views/pages/**/*.vue");

const loadPage: Function = (path: string) => {
  // Standardize path: ensure it starts with ./ and ends with .vue
  const fullPath = `../views/pages/${path}.vue`;
  const importer = pageModules[fullPath];

  if (!importer) {
    console.error(`Page not found: ${fullPath}`);
    return () => Promise.reject(new Error(`Page not found: ${fullPath}`));
  }

  return () => importer().catch((err) => {
    console.error(`Failed to load page ${fullPath}:`, err);
    Notification.showNotification({ status: Constant.STATUS.API.DEFAULT_ERROR });
    throw err;
  });
};

const persyaratan = [
  {
    path: "/proses-persyaratan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/persyaratan/proses/ProsesPersyaratanPage")
  },
  {
    path: "/daftar-persyaratan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/persyaratan/daftar/DaftarPersyaratanPage")
  }
];

const keuangan = [
  {
    path: "/proses-keuangan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/keuangan/proses/ProsesKeuanganPage")
  },
  {
    path: "/daftar-keuangan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/keuangan/daftar/DaftarKeuanganPage")
  }
];

const seragam = [
  {
    path: "/proses-seragam",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/seragam/proses/ProsesSeragamPage")
  },
  {
    path: "/daftar-seragam",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/seragam/daftar/DaftarSeragamPage")
  }
];

const koperasi = [
  {
    path: "/pengambilan-kitab",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengambilan-kitab/proses/PengambilanKitabPage")
  },
  {
    path: "/daftar-pengambilan-kitab",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengambilan-kitab/daftar/DaftarPengambilanKitabPage")
  }
];

const rekap = [
  {
    path: "/rekap-keuangan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/rekapitulasi/keuangan/RekapKeuanganPage")
  },
  {
    path: "/rekap-pendaftar",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/rekapitulasi/pendaftar/RekapPendaftarPage")
  },
  {
    path: "/rekap-persyaratan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/rekapitulasi/persyaratan/RekapPersyaratanPage")
  },
  {
    path: "/rekap-seragam",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/rekapitulasi/seragam/RekapSeragamPage")
  }
];

const santri = [
  {
    path: "daftar-santri",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/santri/daftar/DaftarSantriPage")
  },
  {
    path: "perbaikan-data-santri",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/santri/perbaikan/PerbaikanDataSantriPage")
  },
  {
    path: "validasi-santri-baru",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/santri/validasi/ValidasiSantriBaruPage")
  },
  {
    path: "daftar-validasi",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/santri/validasi/DaftarValidasiPage")
  }
];

const uangsaku = [
  {
    path: "/transaksi-uang-saku",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/uang-saku/transaksi-virtual-account/TransaksiUangSakuPage")
  },
  {
    path: "/daftar-uang-saku",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/uang-saku/daftar/DaftarUangSakuPage")
  },
  {
    path: "/penarikan-dana-merchant",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/uang-saku/penarikan-dana/PenarikanDanaMerchantPage")
  }
];

const pelanggaran = [
  {
    path: "daftar-pelanggaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pelanggaran/DaftarPelanggaranPage")
  }
];

const prestasi = [
  {
    path: "daftar-prestasi",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/prestasi/DaftarPrestasiPage")
  }
];

const kantin = [
  {
    path: "daftar-kantin",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/kantin/DaftarKantinPage")
  }
];

const manajemenKantin = [
  {
    path: "/manajemen-kantin/dashboard",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/dashboard/DashboardOwnerPage")
  },
  {
    path: "/manajemen-kantin/dashboard-kasir",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/dashboard/DashboardCashierPage")
  },
  {
    path: "/manajemen-kantin/kategori-produk",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/kategori-produk/KategoriProdukPage")
  },
  {
    path: "/manajemen-kantin/produk",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/produk/ProdukPage")
  },
  {
    path: "/manajemen-kantin/produk/import",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/produk/ImportProdukPage")
  },
  {
    path: "/manajemen-kantin/stok/masuk",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/stok/StokMasukPage")
  },
  {
    path: "/manajemen-kantin/stok/keluar",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/stok/StokKeluarPage")
  },
  {
    path: "/manajemen-kantin/stok/history",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/stok/HistoryStokPage")
  },
  {
    path: "/manajemen-kantin/transaksi",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/transaksi/DaftarTransaksiPage")
  },
  {
    path: "/manajemen-kantin/laporan/penjualan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/laporan/LaporanPenjualanPage")
  },
  {
    path: "/manajemen-kantin/laporan/keuangan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/laporan/LaporanKeuanganPage")
  },
  {
    path: "/manajemen-kantin/laporan/stok",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/manajemen-kantin/laporan/LaporanStokPage")
  }
];

const pembayaran = [
  {
    path: "/transaksi-va",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/transaksi/TransaksiVirtualAccountPage")
  },
  {
    path: "/transaksi-cash",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/transaksi/TransaksiCashPage")
  },
  {
    path: "/pembayaran-santri",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/pembayaran-santri/PembayaranSantriPage")
  },
  {
    path: "/daftar-pembayaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/daftar-pembayaran/DaftarPembayaranPage")
  },
  {
    path: "/tunggakan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/tunggakan/TunggakanPembayaranPage")
  },
  {
    path: "/khataman",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/khataman/PembayaranKhatamanPage")
  },
  {
    path: "/pos-pembayaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/pos-pembayaran/PosPembayaranPage")
  },
  {
    path: "/penarikan-dana",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pembayaran/penarikan-dana/PenarikanDanaPage")
  }
];

const presensiKegiatan = [
  {
    path: "/daftar-kegiatan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/presensi-kegiatan/daftar/DaftarKegiatanPage")
  }
];

const asesmen = [
  {
    path: "/bank-soal",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/bank-soal/daftar/DaftarBankSoalPage")
  },
  {
    path: "/jawaban-bank-soal",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/bank-soal/jawaban/JawabanBankSoalPage")
  },
  {
    path: "/daftar-peserta",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/bank-soal/daftar-peserta/DaftarPesertaPage")
  }
];

const wakaf = [
  {
    path: "/daftar-wakaf",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/wakaf/daftar/DaftarWakafPage")
  }
];

const pengaturan = [
  {
    path: "/pengaturan-asrama",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/asrama/PengaturanAsramaPage")
  },
  {
    path: "/pengaturan-biaya",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/biaya/PengaturanBiayaPage")
  },
  {
    path: "/pengaturan-persyaratan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/persyaratan/PengaturanPersyaratanPage")
  },
  {
    path: "/pengaturan-seragam",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/seragam/PengaturanSeragamPage")
  },
  {
    path: "/pengaturan-user",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/user/PengaturanUserPage")
  },
  {
    path: "/pengaturan-kuota",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/kuota/PengaturanKuotaPage")
  },
  {
    path: "/pengaturan-wilayah",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/wilayah/PengaturanWilayahPage")
  },
  {
    path: "/pengaturan-menu",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/menu/PengaturanMenuPage")
  },
  {
    path: "/pengaturan-mobile",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/mobile/PengaturanMobilePage")
  },
  {
    path: "/item-pembayaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/item-pembayaran/ItemPembayaranPage")
  }
];

const tuk = [
  {
    path: "/tuk/dashboard",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tuk/dashboard/DashboardPage")
  },
  {
    path: "/tuk/pemasukan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tuk/pemasukan/PemasukanPage")
  },
  {
    path: "/tuk/pengeluaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tuk/pengeluaran/PengeluaranPage")
  },
  {
    path: "/tuk/rekap-pemasukan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tuk/rekap-pemasukan/RekapPemasukanPage")
  },
  {
    path: "/tuk/rekap-pengeluaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tuk/rekap-pengeluaran/RekapPengeluaranPage")
  },
  {
    path: "/pengaturan/bendahara-config",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/tuk-bendahara/BendaharaConfigPage")
  },
  {
    path: "/pengaturan/bendahara-item-access",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/tuk-bendahara/BendaharaItemAccessPage")
  },
  {
    path: "/pengaturan/jenis-pemasukan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/tuk-bendahara/MasterJenisPemasukanPage")
  },
  {
    path: "/pengaturan/jenis-pengeluaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/pengaturan/tuk-bendahara/MasterJenisPengeluaranPage")
  }
];

const tagihan = [
  {
    path: "/tagihan/dashboard",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tagihan/dashboard/TagihanDashboardPage")
  },
  {
    path: "/tagihan/daftar-pembayaran",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tagihan/daftar-pembayaran/TagihanDaftarPembayaranPage")
  },
  {
    path: "/tagihan/daftar-tunggakan",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tagihan/daftar-tunggakan/TagihanDaftarTunggakanPage")
  },
  {
    path: "/tagihan/rekap",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/tagihan/rekap/TagihanRekapPage")
  }
];

let pages = [
  {
    path: "index",
    meta: { requiredAuth: true },
    component: loadPage("authenticated/DashboardPage")
  }, ...persyaratan, ...keuangan, ...seragam, ...rekap, ...santri, ...pembayaran,
  ...uangsaku, ...prestasi, ...pelanggaran, ...kantin, ...manajemenKantin, ...pengaturan, ...koperasi,
  ...presensiKegiatan, ...asesmen, ...wakaf, ...tuk, ...tagihan
];

export default [
  /** route for authenticating on process login user */
  { path: "/", component: loadPage("authenticate/IndexPage"), meta: { deniedForAuth: true } },
  { path: "/privacy-policy", component: loadPage("authenticate/PrivacyPolicy"), meta: { requiredAuth: false } },
  {
    path: "/simak-privacy-policy",
    component: loadPage("authenticate/SimakPrivacyPolicy"),
    meta: { requiredAuth: false }
  },

  {
    path: "/perpus-privacy-policy",
    component: loadPage("authenticate/PerpusPrivacyPolicy"),
    meta: { requiredAuth: false }
  },

  /** route for has authenticated user */
  {
    path: "/", component: loadPage("authenticated/LayoutPage"), meta: { requiredAuth: true },
    children: pages
  },

  /** route for default fallback and default landing */
  { path: "*", component: loadPage("NotFoundPage"), meta: { any: true } },

  /** route for asesmen voting */
  { path: "/e-asesmen", component: loadPage("AsesmenPage"), meta: { deniedForAuth: true } }
];
